import getName from "@gqlapp/config/country/countryToPath"
import React from "react";
import config from '@xem/config'

export default function(code: string){
  let name = getName(code);
  let src = `${config.app.cdn}/icons/country/${name}.svg`;
  return <><img className={'country icon'} src={src} alt=""/></>;
}